export class NumberFormatter {
    constructor(params) {
        return new Intl.NumberFormat(...params);
    }
}

export class YearFormatter {
    format(value) {
        return value;
    }
}
